import Phone from './phone.model';

export default class Holder {
    constructor(){
        this.name = '';
        this.documents = [];
        this.birthDate = '';
        this.phone = new Phone()
    }
}